module.exports = __webpack_public_path__ + "fonts/1700b478b2befa1af9001a9fa69b95ee.txt";